import React, { useState } from 'react'
import { ModerationFilterProps } from './moderation-filter.constants'
import { useModerationFilterStyles } from './moderation-filter.styles'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Card,
  CardContent,
  FormControl,
  SwipeableDrawer,
  TextField,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CloseIcon from '@material-ui/icons/Close'
import { ScreenSize } from '../../settings/device'
import { useModerationFilterHook } from './moderation-filter.hooks'
import { FilterOpenButton } from '../../shared/filter-open-button'

export type StateListItemType = {
  state: string
  value: string
}

export type StateListType = StateListItemType[]

export const ModerationFilter: React.FC<ModerationFilterProps> = (
  props: ModerationFilterProps
) => {
  const classes = useModerationFilterStyles()
  const { t } = useTranslation()
  const [STATE_LIST] = useState<StateListType>([
    // {state: t('filter.state.draft'), value: '0'},
    { state: t('moderation.filter.state.onreview'), value: 'onreview' },
    { state: t('moderation.filter.state.rejected'), value: 'rejected' },
  ])
  const [textFieldLabel, setTextFieldLabel] = useState<string>(
    t('myListingPage.selectItemState')
  )

  const {
    screenSize,
    loading,
    cancelHandler,
    moderationState,
    toggleDrawer,
    applyBtnHandler,
    changeModerationState,
    drawerStatus,
  } = useModerationFilterHook({
    ...props,
  })

  const filterWrapper = () => {
    return (
      <CardContent
        id="moderation-filter-card-content"
        className={`${
          screenSize === ScreenSize.Mobile ? classes.filterWrapper : ''
        }`}
      >
        {
          <div className={`${classes.filterBody}`}>
            {screenSize !== ScreenSize.Desktop && (
              <span className={classes.closeBtn} onClick={toggleDrawer(false)}>
                <CloseIcon />
              </span>
            )}

            <div
              id="filter-states-wrapper"
              className={classes.lookupHolderNonprofit}
            >
              <FormControl variant="outlined" fullWidth>
                <Autocomplete
                  value={
                    STATE_LIST.filter(
                      (item) => item.value! === moderationState
                    )[0] || null
                  }
                  id={'filter-states'}
                  options={STATE_LIST}
                  disabled={loading}
                  autoHighlight
                  getOptionLabel={(option) => option.state as string}
                  onChange={(_, value) => {
                    changeModerationState(value)
                    setTextFieldLabel(
                      value ? value.state : t('myListingPage.selectItemState')
                    )
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={textFieldLabel}
                      variant="outlined"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </FormControl>
            </div>

            {/* Mobile Mode */}
            {screenSize === ScreenSize.Mobile && (
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={applyBtnHandler}
                >
                  {t('filter.apply')}
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  color="primary"
                  onClick={cancelHandler}
                >
                  {t('filter.cancel')}
                </Button>
              </div>
            )}
          </div>
        }
      </CardContent>
    )
  }

  return (
    <>
      <Card className={classes.filterHolder} id="filter-card" elevation={0}>
        {screenSize !== ScreenSize.Desktop && (
          <FilterOpenButton onClick={toggleDrawer(true)} />
        )}
        {screenSize !== ScreenSize.Unknown &&
        screenSize === ScreenSize.Desktop ? (
          filterWrapper()
        ) : (
          <SwipeableDrawer
            id="filter-drawer"
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            open={drawerStatus}
            anchor="left"
            classes={{ paper: classes.drawerPaper }}
          >
            {filterWrapper()}
          </SwipeableDrawer>
        )}
      </Card>
    </>
  )
}
